// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"386":"af719e42","773":"cf54f360","871":"afbae0bc","974":"2ca34ef0"}[chunkId] + ".chunk.css";
};